import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { goods, getTypePrefix  } from '@/api'

/**
 * 获取商品列表
 * @returns {Promise<void>}
 */
export const getGoodsListAction = createAsyncThunk(
    getTypePrefix(goods.getGoodsList),
    async (params) => await okHttp(goods.getGoodsList, {
        method: 'POST',
        ...params
    })
)

/**
 * 获取商品类目列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getCategoryListAction = createAsyncThunk(
    getTypePrefix(goods.getCategoryListUrl),
    async (params) => await okHttp(goods.getCategoryListUrl, {
        method: 'GET',
        params
    })
)

export const getInfiniteListAction = createAsyncThunk(
    getTypePrefix(goods.getInfiniteList),
    async (params) => await okHttp(goods.getInfiniteList, {
        method: 'GET',
	    params
    })
)


